import React from "react";
import { RadioButton } from "primereact/radiobutton";
import { PRINTERS } from "../../../helpers/booking-helper";

function RadioButtonGroup({ printer, setPrinter }) {
    return (
        <div className="flex flex-wrap gap-3 bg-blue-200 p-1.5 rounded">
            <div className="flex align-items-center">
                <p>Printer Type:</p>
            </div>
            {PRINTERS.map((option) => (
                <div key={option.id} className="flex align-items-center">
                    <RadioButton
                        inputId={option.id}
                        name={option.id}
                        value={option.value}
                        onChange={(e) => {
                            setPrinter(e.value);
                            localStorage.setItem("printer_type", e.value);
                        }}
                        checked={printer === option.value}
                    />
                    <label htmlFor={option.id} className="ml-2 text-sm">
                        {option.label}
                    </label>
                </div>
            ))}
        </div>
    );
}

export default RadioButtonGroup;
